import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import facilityService from "../../services/facilityService";
import { ModelCard } from "../../../../components/ModelCard";

const ModelConfigurationTab = () => {
  const [models, setModels] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    facilityService
      .getFacilityModelSettings()
      .then((data) => setModels(data))
      .catch((error) => console.error("Error fetching model settings:", error))
      .finally(() => setIsLoading(false));
  }, []);

  const handleUpdateSettings = async (facilityConfigId, updatedModelData) => {
    const originalModels = [...models];
    setModels((current) => {
      if (updatedModelData.is_default_for_facility !== true) {
        return current.map((m) => (m.id === facilityConfigId ? { ...m, ...updatedModelData } : m));
      }
      return current.map((m) =>
        m.id === facilityConfigId ? { ...m, ...updatedModelData } : { ...m, is_default_for_facility: false }
      );
    });

    try {
      await facilityService.updateFacilityModelSettings(facilityConfigId, updatedModelData);
      toast.success(`Settings saved for ${updatedModelData.display_name}.`);
    } catch (error) {
      toast.error(`Failed to save: ${error.message || "Server error"}`);
      setModels(originalModels);
    }
  };

  if (isLoading) {
    return <div className="py-16 text-center text-gray-500">Loading models...</div>;
  }

  return (
    <div>
      <div className="mb-5 flex items-center justify-between">
        <div>
          <h3 className="text-base font-bold text-gray-900">Model configuration</h3>
          <p className="text-sm text-gray-500">Models available to users in this facility</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-3">
        {models.map((model) => (
          <ModelCard key={model.id} model={model} onUpdateSettings={handleUpdateSettings} />
        ))}
      </div>
    </div>
  );
};

export default ModelConfigurationTab;
